export const ACCESSORY_COVERAGE_OPTIONS = [
  { value: 'UNDECLARED', label: 'Chưa khai báo' },
  { value: 'NONE', label: 'Không bảo hành' },
  { value: 'PERIOD', label: 'Có bảo hành' },
];

export const getWarrantyPackageId = (value) => value?.value ?? value?.id ?? value ?? null;

export const formatWarrantyMonths = (months) => {
  const value = Number(months);
  return Number.isInteger(value) && value > 0 ? `${value} tháng` : 'Chưa khai báo';
};

export const formatAccessoryWarranty = (coverage, months) => {
  if (coverage === 'NONE') return 'Không bảo hành';
  if (coverage === 'PERIOD') return formatWarrantyMonths(months);
  return 'Chưa khai báo';
};

export const findWarrantyPackage = (options = [], id) => options.find(
  (option) => String(option.warranty_package_id ?? option.value) === String(getWarrantyPackageId(id)),
);

export const preserveUnmappedLegacyWarranty = (product = {}) => {
  if (!getWarrantyPackageId(product.warranty_package_id) && getWarrantyPackageId(product.warranty_period_id)) {
    const { warranty_package_id, ...legacyProduct } = product;
    return legacyProduct;
  }
  return product;
};
